// extracted by mini-css-extract-plugin
export default {"install":"InstallPrompt_install__8IynP","btn":"InstallPrompt_btn__On4jC"};